import { Grid, withStyles } from "@material-ui/core";
import React, { Component } from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import styles from "./styles";
import { formatDistanceStrict } from "date-fns";
import { pickupOrProNumbersString } from "../../utils";
import { truncate } from "lodash";

export class DriverMessageNotification extends Component {
  getDriverInfo = () => {
    const { data } = this.props;
    if (!data.driver) {
      return null;
    }
    if (data.driver?.driverName) {
      return `${data.driver?.driverName} (${data.driver?.driverNumber})`;
    }
    return data.driver?.driverNumber;
  };

  openDriverChat = () => {
    const { data, openDriverChatBox} = this.props;
    if (!data.driver) {
      return null;
    }
    openDriverChatBox(data.driver);
  };

  render() {
    const { classes, data } = this.props;
    const shipmentNumbers =
      data.metadata?.pickupNumbers || data.metadata?.proNumbers;
    return (
      <div onClick={this.openDriverChat} className={classes.outerContainer}>
        <Grid
          container
          classes={{
            container: `${classes.notificationContainer}`,
          }}
        >
          <Grid item xs={3} className={classes.notificationIconContainer}>
            <MailOutlineIcon className={classes.notificationIcon} />
          </Grid>
          <Grid item xs={9} className={classes.info}>
            <div className={classes.title}>{this.getDriverInfo()}</div>
            <div className={classes.subtitle}>
              {data?.metadata?.stopName ? (
                <span className={classes.link}>@{data.metadata.stopName}</span>
              ) : null}
              {shipmentNumbers?.length ? (
                <span className={classes.link}>
                  {pickupOrProNumbersString(shipmentNumbers)}
                </span>
              ) : null}{" "}
              {truncate(data.message, { length: 40, separator: "..." })}
            </div>
            <div className={classes.time}>
              {formatDistanceStrict(new Date(data.messageDateTs), new Date(), {
                addSuffix: true,
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(DriverMessageNotification);
